import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { LineBotService } from '../../../_services/line-bot.service';
import { LineBotAccountModel } from '../../../_models/line-bot-account';

@Component({
    selector: 'app-add-line-bot-account',
    templateUrl: './add-line-bot-account.component.html',
})

export class AddLineBotComponent extends DialogComponent<LineBotAccountModel, boolean> implements OnInit {
    model: any = {};
    loading = false;
    message: string;
    returnUrl: string;
    linebot_channel_name: string;
    linebot_channel_token: string;
    linebot_channel_secret: string;
    qr_code: string;
    type: number = 1;
    id: number;
    typeArray : any[] = [
        {'value' : 1, 'text' : "コインのコンフィグ"},
        {'value' : 2, 'text' : "その他"}
    ];

    focusEventEmitter = new EventEmitter<boolean>();

    constructor(
        dialogService: DialogService,
        private lineBotService: LineBotService,
    ) {
        super(dialogService);
    }

    ngOnInit() {
        this.model.id = this.id;
        this.model.linebot_channel_name = this.linebot_channel_name;
        this.model.linebot_channel_token = this.linebot_channel_token;
        this.model.linebot_channel_secret = this.linebot_channel_secret;
        this.model.qr_code = this.qr_code;
        this.model.type = this.type;
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    save() {
        this.loading = true;
        this.message = '';
        this.lineBotService.save(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            } else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/line-bot-account/add-line-bot-account/add-line-bot-account.component.ts